import React, { useEffect, useState } from "react";
import { getCenterById, getDoctorById } from "../services/centerService";
import { useParams } from "react-router-dom";
import bottomArrow from "../assets/icons/bottom-arrow.png";
import { Link } from "react-router-dom";

export default function MedicalCenterDetail() {
  const [centerData, setCenterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const [openDescription, setopenDescription] = useState(false);

  useEffect(() => {
    const loadFullDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        // بررسی وجود ID
        if (!id) {
          console.error("خطا: شناسه (id) به کامپوننت پاس داده نشده است.");
          throw new Error("شناسه مرکز درمانی ارسال نشده است.");
        }

        console.log("در حال ارسال درخواست برای مرکز با شناسه:", id);
        const centerResponse = await getCenterById(id);
        console.log("پاسخ دریافتی از سرور برای مرکز درمانی:", centerResponse);

        // منعطف‌سازی شرط بررسی پاسخ:
        // اگر پاسخ مستقیم بود یا داخل یک آبجکت حاوی دیتای موفقیت‌آمیز
        const rawCenter = centerResponse?.data || centerResponse;

        if (rawCenter && (rawCenter.uuid || rawCenter.id)) {
          let fullDoctorsList = [];

          // دریافت اطلاعات تک‌تک پزشکان
          if (
            Array.isArray(rawCenter.doctor_list) &&
            rawCenter.doctor_list.length > 0
          ) {
            const doctorPromises = rawCenter.doctor_list.map(
              async (docItem) => {
                try {
                  const docResponse = await getDoctorById(docItem.doctor_id);
                  const rawDoc =
                    docResponse?.data?.[0] || docResponse?.data || docResponse;
                  if (rawDoc) {
                    return {
                      id: rawDoc.id || docItem.doctor_id,
                      name: rawDoc.name || "بدون نام",
                      specialty: rawDoc.title || "پزشک عمومی",
                      rating: rawDoc.score ? String(rawDoc.score) : "۴.۰",
                      reviews: rawDoc.comments ? String(rawDoc.comments) : "۰",
                      success: rawDoc.count ? String(rawDoc.count) : "۰",
                      image: rawDoc.thumb,
                    };
                  }
                } catch (docErr) {
                  console.error(
                    `خطا در دریافت اطلاعات پزشک با شناسه ${docItem.doctor_id}:`,
                    docErr,
                  );
                }
                return null;
              },
            );

            const resolvedDoctors = await Promise.all(doctorPromises);
            fullDoctorsList = resolvedDoctors.filter(Boolean);
          }

          // نگاشت نهایی به ساختار صفحه
          const formattedData = {
            id: rawCenter.uuid || rawCenter.id,
            title: rawCenter.title || "مرکز درمانی بدون عنوان",
            category: rawCenter.category_title || "بیمارستان",
            group: rawCenter.group_title || "عمومی",
            type: rawCenter.type || "دولتی",
            isOpen: rawCenter.is_open !== undefined ? rawCenter.is_open : true,
            city: rawCenter.city_title || "",
            coverImage: rawCenter.cover_photo,
            logo: rawCenter.thumbnail,
            description: rawCenter.description,
            services: Array.isArray(rawCenter.service_list)
              ? rawCenter.service_list.map((item) => item.title)
              : [],
            departments: Array.isArray(rawCenter.department_list)
              ? rawCenter.department_list.map((item) => item.title)
              : [],
            contact: {
              city: rawCenter.city_title || "",
              address: rawCenter.address || "آدرس ثبت نشده است",
              phone: Array.isArray(rawCenter.phones)
                ? rawCenter.phones.join(" - ")
                : rawCenter.phones || "بدون شماره تماس",
              workHours: rawCenter.work_time || "شبانه روزی",
            },
            insurances: Array.isArray(rawCenter.insurance_list)
              ? rawCenter.insurance_list.map((item) => item.title)
              : [],
            doctors: fullDoctorsList,
          };

          setCenterData(formattedData);
        } else {
          throw new Error(
            "پاسخ دریافتی از سرور معتبر نیست یا ساختار آن تغییر کرده است.",
          );
        }
      } catch (err) {
        // لاگ جزئیات خطا در کنسول جهت خطایابی راحت‌تر شما
        console.error(
          "جزئیات خطای رخ داده در کامپوننت MedicalCenterDetail:",
          err,
        );
        setError(
          err.message ||
            "خطا در برقراری ارتباط با سرور. لطفا مجدداً تلاش کنید.",
        );
      } finally {
        setLoading(false);
      }
    };

    loadFullDetails();
  }, [id]);

  const boxStyle =
    "bg-white rounded-2xl p-4 sm:p-5 md:p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300 w-full overflow-hidden";

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#49D1CD]"></div>
        <p className="mt-4 text-gray-500 text-sm">
          در حال دریافت و بارگذاری اطلاعات مرکز...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center p-4">
        <div className="bg-rose-50 text-rose-600 p-6 rounded-2xl border border-rose-100 max-w-md">
          <p className="font-bold mb-2">مشکلی پیش آمده است</p>
          <p className="text-sm text-gray-500 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2 bg-[#49D1CD] hover:bg-[#3bb8b4] text-white text-sm font-bold rounded-xl transition-colors"
          >
            تلاش مجدد
          </button>
        </div>
      </div>
    );
  }

  if (!centerData) return null;

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="pt-2 lg:pt-0 lg:-mt-3 flex flex-col gap-7 md:w-[85%] w-full">
        {/* هدر */}
        <div
          className="relative w-full overflow-hidden rounded-2xl bg-gray-900
        shadow-sm flex flex-col justify-end min-h-[22rem] md:min-h-[400px]"
        >
          <img
            src={`https://bit.medizen.ir/i/${centerData.coverImage}`}
            alt="نمای مرکز درمانی"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-black/10"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-start md:items-end gap-4 px-4 py-5 sm:p-6 mt-auto w-full">
            <div className="flex w-full min-w-0 flex-1 flex-col gap-3">
              <div className="flex flex-1 flex-col pt-5">
                <div className="flex flex-row items-center gap-2 md:gap-3">
                  <div className="relative shrink-0">
                    <img
                      src={`https://bit.medizen.ir/i/${centerData.logo}`}
                      alt={centerData.title}
                      className="h-12 w-12 lg:h-20 lg:w-20 rounded-full border-2 border-gray-50 object-cover shadow-sm"
                    />
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="flex w-full items-center justify-between mb-2 md:mb-4">
                      <div className="min-w-0 flex-1">
                        <h1 className="text-[16px] md:text-[22px] font-bold text-white leading-tight">
                          {centerData.title}
                        </h1>
                      </div>

                      <div className="flex shrink-0 items-center justify-end gap-1 lg:-mb-20">
                        {centerData.type && (
                          <span className="whitespace-nowrap rounded-full bg-gray-200 px-2 py-0.5 md:px-3 md:py-1 text-[11px] md:text-[13px] font-medium text-gray-600 lg:text-xs">
                            {centerData.type}
                          </span>
                        )}

                        {typeof centerData.isOpen === "boolean" && (
                          <span
                            className={`whitespace-nowrap rounded-full px-2 py-0.5 md:px-3 md:py-1 md:text-[13px] text-[11px] font-medium lg:text-xs ${
                              centerData.isOpen
                                ? "bg-emerald-100 text-emerald-600"
                                : "bg-rose-100 text-rose-600"
                            }`}
                          >
                            {centerData.isOpen ? "باز" : "بسته"}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-3 md:gap-7 text-xs text-gray-400 lg:text-sm">
                      {centerData.category && (
                        <div className="flex min-w-0 items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 shrink-0 text-gray-400"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect
                              x="3"
                              y="4"
                              width="18"
                              height="18"
                              rx="2"
                              ry="2"
                            ></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                          </svg>
                          <span className="line-clamp-1">
                            {centerData.category}
                          </span>
                        </div>
                      )}

                      {centerData.group && (
                        <div className="flex min-w-0 items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 shrink-0 text-gray-400"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                          </svg>
                          <span className="line-clamp-1">
                            {centerData.group}
                          </span>
                        </div>
                      )}

                      {centerData.city && (
                        <div className="flex min-w-0 items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-3 w-4 shrink-0 text-gray-400"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                          </svg>
                          <span className="line-clamp-1 leading-relaxed">
                            {centerData.city}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* بخش پایینی (ستون‌ها) */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5 items-start w-full">
          <div className="flex flex-col gap-3 lg:col-span-2 lg:sticky lg:top-4 w-full min-w-0">
            {/* توضیحات */}
            <div className={boxStyle}>
              <div
                onClick={() => setopenDescription(!openDescription)}
                className={`flex items-center justify-between cursor-pointer my-2 ${
                  openDescription ? "mb-5" : ""
                }`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    className="w-7 h-7 text-[#49D1CD]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>

                  <h2 className="text-base sm:text-lg font-bold text-gray-900">
                    درباره کلینیک
                  </h2>
                </div>

                {/* arrow */}
                <img
                  alt=""
                  src={bottomArrow}
                  className={`w-3 transition-transform opacity-80 duration-300 ${
                    openDescription ? "rotate-180" : ""
                  }`}
                />
              </div>

              {/* content */}
              {openDescription && (
                <div>
                  <p className="leading-relaxed text-justify break-words">
                    {centerData.description}
                  </p>
                </div>
              )}
            </div>
            {/* اطلاعات تماس */}
            <div className={boxStyle}>
              <div className="flex items-center gap-2 mb-5">
                <svg
                  className="w-6 h-6 text-[#49D1CD]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  ></path>
                </svg>
                <h2 className="text-base sm:text-lg font-bold text-gray-900">
                  اطلاعات تماس
                </h2>
              </div>
              <div className="space-y-4 text-gray-700 text-sm">
                <div className="flex items-start gap-3">
                  <svg
                    className="w-5 h-5 text-gray-400 shrink-0 mt-0.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.243-4.243a8 8 0 1111.314 0z"
                    ></path>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                  </svg>
                  <p className="leading-relaxed break-words flex-1 min-w-0">
                    {centerData.contact.city + "، " + centerData.contact.address}{" "}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-gray-400 shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    ></path>
                  </svg>
                  <p
                    dir="ltr"
                    className="text-right flex-1 min-w-0 truncate"
                  >
                    {centerData.contact.phone}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-gray-400 shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                  <p className="flex-1 min-w-0 truncate">
                    {centerData.contact.workHours}
                  </p>
                </div>
              </div>
            </div>

            {/* خدمات */}
            <div className={boxStyle}>
              <div className="flex items-center gap-2 mb-4">
                <svg
                  className="w-6 h-6 text-[#49D1CD]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                  ></path>
                </svg>
                <h2 className="text-base sm:text-lg font-bold text-gray-900">
                  خدمات قابل ارائه
                </h2>
              </div>
              <div className="flex flex-wrap gap-2">
                {centerData.services.length > 0 ? (
                  centerData.services.map((service, index) => (
                    <span
                      key={index}
                      className="bg-gray-50 border border-gray-200 text-gray-700 px-3 py-1.5 rounded-xl text-xs sm:text-sm font-medium hover:bg-gray-100 transition-colors"
                    >
                      {service}
                    </span>
                  ))
                ) : (
                  <span className="text-xs text-gray-400">
                    خدماتی تعریف نشده است.
                  </span>
                )}
              </div>
            </div>

            {/* بخش‌ها */}
            <div className={boxStyle}>
              <div className="flex items-center gap-2 mb-5">
                <svg
                  className="w-6 h-6 text-[#49D1CD]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  ></path>
                </svg>
                <h2 className="text-base sm:text-lg font-bold text-gray-900">
                  بخش‌های مرکز
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4">
                {centerData.departments.length > 0 ? (
                  centerData.departments.map((dept, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-2 text-sm text-gray-700"
                    >
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400 shrink-0"></div>
                      <span className="truncate">{dept}</span>
                    </div>
                  ))
                ) : (
                  <span className="text-xs text-gray-400">
                    بخش فعالی وجود ندارد.
                  </span>
                )}
              </div>
            </div>

            {/* بیمه‌ها */}
            <div className={boxStyle}>
              <div className="flex items-center gap-2 mb-5">
                <svg
                  className="w-6 h-6 text-[#49D1CD]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  ></path>
                </svg>
                <h2 className="text-base sm:text-lg font-bold text-gray-900">
                  بیمه‌های طرف قرارداد
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4">
                {centerData.insurances.length > 0 ? (
                  centerData.insurances.map((ins, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-2 text-sm text-gray-700"
                    >
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400 shrink-0"></div>
                      <span className="truncate">{ins}</span>
                    </div>
                  ))
                ) : (
                  <span className="text-xs text-gray-400 col-span-2">
                    اطلاعات بیمه‌ای یافت نشد.
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* ستون چپ - لیست پزشکان */}
          <div className="lg:col-span-3 w-full min-w-0">
            <div className={`${boxStyle} flex flex-col gap-4 sm:gap-7`}>
              <div className="flex items-center justify-between border-b border-gray-200 pt-2 pb-6">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900">
                  پزشکان مرکز
                </h2>
                <span className="text-gray-500 px-2 py-1 rounded-lg text-xs sm:text-sm">
                  {centerData.doctors.length} پزشک
                </span>
              </div>

              <div className="flex flex-col gap-4">
                {centerData.doctors.length > 0 ? (
                  centerData.doctors.map((doc, index) => (
                    <div
                      key={index}
                      className="group flex flex-col sm:flex-row items-center gap-4 p-5 border border-gray-200 rounded-2xl bg-white hover:border-[#49D1CD]/50 hover:shadow-md transition-all duration-300 w-full"
                    >
                      <div className="flex flex-col items-center relative">
                        <div className="relative">
                          <img
                            src={`https://bit.medizen.ir/i/${doc.image}`}
                            alt={doc.name}
                            className="w-24 h-24 rounded-[28px] object-cover border border-gray-100 group-hover:border-[#49D1CD] transition-colors p-1 -mt-1 mb-1"
                          />

                          <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-1 bg-white px-2 py-0.5 rounded-full border border-gray-100">
                            <svg
                              className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400"
                              viewBox="0 0 20 20"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.39 8.72c-.783-.57-.38-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
                            </svg>
                            <span className="text-xs font-medium text-gray-700">
                              {doc.rating}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col flex-1 text-center sm:text-right justify-center">
                        <h3 className="text-base sm:text-[16px] font-bold text-gray-900">
                          {doc.name}
                        </h3>

                        <div className="text-sm font-medium text-[#49D1CD] mt-1">
                          {doc.specialty}
                        </div>

                        <div className="flex flex-wrap items-center justify-center sm:justify-start gap-4 mt-3 text-sm text-gray-500">
                          <div className="flex items-center gap-1.5">
                            <svg
                              className="w-4 h-4 text-gray-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                              />
                            </svg>
                            <span>{doc.reviews} دیدگاه</span>
                          </div>

                          <div className="flex items-center gap-1.5">
                            <svg
                              className="w-4 h-4 text-gray-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span>{doc.success} نوبت موفق</span>
                          </div>
                        </div>
                      </div>

                      <div className="w-full sm:w-auto flex justify-center sm:justify-end">
                        <Link
                          to={`/doctor/${doc.id}`}
                          className="w-full sm:w-auto px-6 py-2.5 bg-[#49D1CD] hover:bg-[#3bb8b4] text-white text-sm font-bold rounded-xl transition-colors shadow-sm"
                        >
                          دریافت نوبت
                        </Link>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-8 text-gray-400 text-sm">
                    پزشکی در حال حاضر برای این مرکز تعریف نشده است.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
